import { FieldValidator } from '@ov-suite/helpers-angular';
import { UserModel } from '@ov-suite/models-idm';
import { OvAutoService } from '@ov-suite/services';
import gql from 'graphql-tag';
import { Injectable } from '@angular/core';

@Injectable()
export class EmailValidator implements FieldValidator<UserModel> {
  errorMessage = 'Email Address already In Use';

  constructor(private readonly ovAutoService: OvAutoService) {}

  async validateCreate(user: UserModel) {
    return this.validate(user);
  }

  async validateUpdate(user: UserModel) {
    return this.validate(user);
  }

  async validate(user: UserModel): Promise<boolean> {
    if (!user.email) {
      return true;
    }

    return await this.validateUserEmail(user);
  }

  async validateUserEmail(user: UserModel): Promise<boolean> {
    if (user.id) {
      return await this.validateUpdateEmail(user.id, user.email);
    } else {
      return await this.validateCreateEmail(user.email);
    }
  }

  validateUpdateEmail(id: number, email: string): Promise<boolean> {
    return this.ovAutoService.apollo
      .query<boolean>({
        query: gql(`query validateUpdateEmail($id: Int!, $email: String!) {
          validateUpdateEmail(id: $id, email: $email)
        }`),
        variables: {
          id,
          email,
        },
      })
      .toPromise()
      .then(res => res.data['validateUpdateEmail']);
  }

  validateCreateEmail(email: string): Promise<boolean> {
    return this.ovAutoService.apollo
      .query<boolean>({
        query: gql(`query checkEmailExists($email: String!) {
          checkEmailExists(email: $email)
        }`),
        variables: {
          email,
        },
      })
      .toPromise()
      .then(res => {
        return !res.data['checkEmailExists']
      });
  }

  async required(): Promise<boolean> {
    return false;
  }
}
